<script setup>
import { getI18n } from '@/plugins/i18n'

defineProps({
  avatar: {
    type: String,
    required: false,
    default: null,
  },
  avatarIcon: {
    type: String,
    required: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  collapsible: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:compact'])
const i18n = getI18n()
</script>

<template>
  <q-card-section class="cdh q-py-sm" :class="{ 'cdh--compact': compact }">
    <q-avatar v-if="avatar" class="cdh__avatar">
      <q-img
        loading="lazy"
        fit="contain"
        spinner-color="black"
        :src="avatar"
      />
    </q-avatar>
    <q-icon
      v-else
      class="cdh__avatar cdh__avatar--icon"
      color="grey-5"
      :name="avatarIcon"
    />
    <div class="cdh__chips">
      <slot name="chips" />
    </div>
  </q-card-section>
  <q-slide-transition>
    <div v-show="!compact">
      <slot name="info" />
    </div>
  </q-slide-transition>
  <div v-if="$slots.info || collapsible" class="flex flex-center">
    <q-btn
      flat
      no-caps
      size="sm"
      color="primary"
      :ripple="false"
      :icon-right="compact ? 'mdi-chevron-down' : 'mdi-chevron-up'"
      :label="i18n.t(compact ? 'common.showMore' : 'common.showLess')"
      @click="emit('update:compact', !compact)"
    />
  </div>
  <q-separator class="q-my-sm" />
</template>

<style scoped>
.cdh {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  transition: gap 0.3s ease;
}
.cdh--compact {
  flex-direction: row;
  justify-content: space-between;
  gap: 0.5rem;
}
.cdh__avatar {
  width: 15rem;
  height: 15rem;
  transition: width 0.3s ease, height 0.3s ease;
}
.cdh__avatar--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10rem;
  transition: font-size 0.3s ease;
}
.cdh--compact .cdh__avatar {
  width: 4rem;
  height: 4rem;
}
.cdh--compact .cdh__avatar--icon {
  font-size: 4rem;
}
.cdh__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  align-items: center;
  justify-content: center;
}
.cdh--compact .cdh__chips {
  justify-content: flex-end;
}
</style>
